"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FAQPage = function FAQPage(_ref) {
  var _ref$questions = _ref.questions,
      questions = _ref$questions === void 0 ? [] : _ref$questions;
  var base = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage'
  };
  var modifiedQuestionsArray = questions.map(function (q) {
    return {
      '@type': 'Question',
      name: q.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: q.answer
      }
    };
  });
  base.mainEntity = modifiedQuestionsArray;
  return _react.default.createElement("script", {
    type: "application/ld+json"
  }, JSON.stringify(base));
};

FAQPage.propTypes = {
  questions: _propTypes.default.arrayOf(_propTypes.default.shape({
    question: _propTypes.default.string.isRequired,
    answer: _propTypes.default.string.isRequired
  }))
};
var _default = FAQPage;
exports.default = _default;
//# sourceMappingURL=index.js.map